<template>
  <div class="user-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :initialSearchFilter="initialSearchFilter"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">

      <ui-button :color="'purple'"
                 @click="toggleExcel(true)">
        <i class="xi-view-list"></i> 엑셀 다운로드
      </ui-button>
    </template-search-list>
    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :apiParam="apiParam"
                     :menu="'user'"
                     :reload="reload"
                     @button="button"
                     @reload="reloadList"
                     @deleteUser="deleteUser">
    </template-detail>
    <excel-column-select :excelDownload="excelDownload"
                         :metaApi="excelListMetaApi"
                         :listApi="listApi"
                         :searchFilter="initialSearchFilter"
                         @export="excelExport"
                         @close="toggleExcel(false)"/>
  </div>
</template>

<script>

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'
import TemplateInsert from '@/components/_template/Insert'
import UiButton from '@/components/_ui/UiButton'

import Excel from '@/utils/excel-export'
import ExcelColumnSelect from '@/components/_template/ExcelColumnSelect'
import { EventBus } from '@/utils/event-bus'
import { NODE_ENV, STORAGE_ITEM } from '@/utils/constants'
import { getGuideList } from '@/api/guide'
import { alertError } from '@/utils/tools'
import {getUserList, deleteUser, getUserExcelMeta, getUserInfo, editUserInfo} from '../../../api/user'
import {mapGetters} from "vuex";

export default {
  name: 'UserList',
  components: {
    ExcelColumnSelect,
    TemplateSearchList,
    TemplateDetail,
    TemplateInsert,
    UiButton
  },
  created () {
    // console.log('eventbus: ', EventBus.$on('searchData', this.apiParam))
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.userId) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.userId = searchData.userId
        this.initialSearchFilter.userIdExact = true
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  computed: {
    ...mapGetters([
      'locale'
    ]),
  },
  methods: {
    deleteUser () {
      let confirmed = confirm('해당 회원이 강제 탈퇴 처리되며, 복구가 불가합니다. \n정말로 강제 탈퇴하시겠습니까?')
      if (confirmed) {
        EventBus.$emit('onLoading', true)
        deleteUser({
          id: this.userId
        }, true).then(response => {
          this.showDetail({ id: this.userId })
        }).catch(error => {
          alertError('사용자 강제탈퇴 처리에 실패 했습니다.', error)
        }).finally(() => {
          EventBus.$emit('onLoading', false)
        })
      }
    },
    showDetail (data) {
      this.apiParam = { id: data.id }
      this.userId = data.id
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    toggleChange (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.change = !this.show.change
      } else {
        this.show.change = value
      }
    },
    toggleExcel (value = false) {
      this.excelDownload = value
    },
    excelExport (col, data, selectCol) {
      const fileName = 'forum_user'
      const excel = new Excel()
      EventBus.$emit('onLoading', true)
      excel.setExcelData('user', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        }).catch(e => {
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.initialSearchFilter = value
    },
    button (value, data) {
      const nameMap = {
        userForum: 'User',
        postReplyForum: 'PostReply'
      }

      const param = {}

      if (value === 'userForum') {
        param.userId = data
      }

      localStorage.setItem(STORAGE_ITEM.searchData, JSON.stringify(param))
      const route = this.$router.resolve({ name: nameMap[value], params: this.apiParam })
      window.open(route.href, '_blank')
    }
  },
  data () {
    return {
      reload: 0,

      infoApi: getUserInfo,
      apiParam: null,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '상세 보기',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      editApi: editUserInfo,
      listApi: getUserList,
      defaultSortBy: '-createdAt',
      show: {
        insert: false,
        change: false
      },
      excelDownload: false,
      initialSearchFilter: null,
      excelListMetaApi: getUserExcelMeta,
      userId: null
    }
  }
}
</script>

<style lang="scss" scoped>
.user-list-wrap {
}
</style>
